import { Component, OnInit, Input, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';

import * as State from '@shared/state';
import { Controllers } from '@shared/core/controllers';

import { Observable } from 'rxjs';

@Component({
    selector: 'shared-wizzard-special-instructions',
    templateUrl: './wizzard-special-instructions.shared.component.html',
    styleUrls: ['./wizzard-special-instructions.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class WizzardSpecialInstructionsComponent implements OnInit {
    public isMenuFlow: boolean = true;
    @Input() public isExpanded: boolean; /* Required to used for scroll directive */
    @Input() public type: State.MODAL_TYPE;
    @Output() public onToggle: EventEmitter<boolean> = new EventEmitter();

    public specialInstructions$: Observable<string>;

    constructor(
        public controllers: Controllers,
    ) { }

    ngOnInit(): void {
        if (this.type === 'product') {
            this.isMenuFlow = false;
        }

        this.specialInstructions$ = this.controllers.wizzard.getSpecialInstructions(this.type);
    }

    public handleChange($event: OLO.Components.IPrevNextEvent): void {
        this.controllers.wizzard.setWizzardSpecialInstructions(this.type, $event.next as string);
    }

    public handleToggle($event: boolean): void {
        this.onToggle.emit($event);
        this.isExpanded = $event;
    }
}
